export const SEARCH_SUGGESTION_CLASS = 'search-suggestion';
export const SEARCH_BAR_WRAPPER_CLASS = 'search-bar-wrapper';
export const SUGGESTIONS_WRAPPER_CLASS = 'search-suggestions-wrapper';
export const SEARCH_CLOSE_BUTTON_CLASS = 'search-bar-close-button';
